<template>
    <div class="timer2">
        <template v-if="!stop">
            <span class="timer_text">{{ $t('partido.entradas_disponibles') }}:</span> {{ time_left_formatted }}
        </template>
        <template v-else>
            {{ $t('partido.time_out') }}
        </template>
        <ModalCuentaAtras @close="closeTerminado" />
        <ModalCuentraAtrasAviso :tiempo="time_left_formatted" @close="close('sesion-aviso')" />
    </div>
</template>

<script>
    import ModalCuentaAtras from './ModalCuentaAtras.vue';
    import ModalCuentraAtrasAviso from './ModalCuentraAtrasAviso.vue';
    export default {
        props: {
            tiempo: {
                type: Number,
                default: 15
            }
        },
        data() {
            return {
                stop: true,
                reset : false,
                timeRef: null,
                time_left_object: null,
            }
        },
        created() {
            this.timeRef = moment();
            this.restartTimer();
            this.startTimer();
        },
        computed: {
            time_left_formatted: function() {
                var diferencia = moment.duration(this.$store.state.timeEnd.diff(this.timeRef));
                var minutos = diferencia.minutes();
                var segundos = diferencia.seconds();
                
                if(minutos === 5 && segundos == 0){
                    this.show('sesion-aviso');
                    this.show('carrito-aviso');
                }
                
                if (this.stop){
                    return this.stop;
                }

                return minutos + ':' + (segundos < 10 ? '0' : '') + segundos;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
        },
        methods: {
            startTimer: function() {
                this.$store.state.timeStart = moment();
                this.$store.state.timeEnd = moment().add(this.tiempo, 'minutes');
                this.stop = false;
                this.reset = false;
                
                this.time_left_object = setInterval(() => {
                    var ahora = moment();
                    var diferencia = moment.duration(this.$store.state.timeEnd.diff(ahora));
                    if (diferencia.minutes() <= 0 && diferencia.seconds() <= 0 && !this.reset) {
                        this.reset = true;
                        this.stop = true;
                        clearInterval(this.time_left_object);

                        //el tiempo se acaba, asi que borro sesion
                        if (sessionStorage.getItem('session_id')) {
                            //el tiempo se acaba, asi que borro sesion
                            const params = {
                                session_id: sessionStorage.getItem('session_id'),
                                filters: {
                                    session_id: sessionStorage.getItem('session_id'),
                                    tid: this.configuracion.hash_teatro
                                },
                                tid: this.configuracion.hash_teatro,
                            };

                            this.$store.dispatch(this.config.getVuexAlias('front.borrar.sesion'), params).then(res => {
                            });

                            sessionStorage.removeItem('session_id');
                        }

                        this.show('sesion-terminada');
                        this.$emit('tiempoTerminado');
                        this.$emit('close');
                        this.restartTimer();
                    }
                    this.timeRef = ahora;
                }, 1000);
            },
            show(data) {
                this.$modal.show(data);
            },
            closeTerminado() {
                this.restartTimer();
                this.startTimer();
                this.$modal.hide('sesion-terminada');
            },
            close(data){
                this.$modal.hide(data);
            },
            restartTimer: function() {
                clearInterval(this.time_left_object);
                this.time_left = this.time_left_conf;
            },
        },
        watch : {
            time_left() {
                if (this.time_left < 0) {
                    this.show('sesion-terminada');
                }
            }
        },
        components: {
            ModalCuentaAtras, ModalCuentraAtrasAviso
        }
    }
</script>

<style scoped>
.timer2 {
    position: fixed;
    font-weight: 700;
    text-align: center;
    background-color: var(--altcolor);
    color: var(--alttextcolor);
    border-bottom: 1px solid var(--alttextcolor);
    font-size: 28px;
    padding: 5px 0;
    line-height: 1;
    left: 0;
    bottom: 0;
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 4;
}

.timer_text {
    display: block;
    font-size: 16px;
    margin: 4px 5px 4px 0;
    text-align: right;
    font-family: 'Oswald', sans-serif;
    text-transform: uppercase;
}

@media (min-width: 992px) {
    .timer2 {
        padding: 0px;
        bottom: inherit;
        top: 0;
    }
}
</style>
